
                var jq = window.jQuery;
                Object.defineProperty(jq, '__esModule', { value: true });
                jq.default = jq;
                module.exports = jq;
            